{
  "filters": {
    "state": "État",
    "any": "Peu importe",
    "approved": "Approuvé",
    "rejected": "Refusé",
    "awaitingReview": "Examen en attente",
    "organization": "Organisation",
    "clientName": "Nom du client",
    "requestedDate": "Date de demande",
    "approvedDate": "Date d'approbation",
    "daysWaiting": "Jours d'attente",
    "document": "Document",
    "name": "Nom",
    "source": "Source",
    "sourceOptions": {
      "USER": "Utilisateur",
      "FLINKS": "Flinks"
    },
    "failReason": "Motif de l'échec",
    "transitNumber": "Numéro de transit",
    "institutionNumber": "Numéro de l'institution",
    "bankAccountNumber": "Numéro de compte bancaire",
    "actions": "Actions",
    "stateOptions": {
      "AWAITING_REVIEW": "Examen en attente",
      "APPROVED": "Approuvé",
      "REJECTED": "Refusé",
      "ARCHIVED": "Archivé"
    }
  },
  "noFile": "Aucun document téléchargé!",
  "bankAccountTransitions": {
    "approve": "Approuver",
    "reject": "Refuser"
  },
  "moderateBankAccount": "Confirmez-vous?",
  "confirmationDialogTitle": "Voulez-vous vraiment {{transition}} ce compte bancaire?",
  "bankAccountPostfix": "Compte bancaire de",
  "bankAccountTitle": "Compte bancaire de {{name}}",
  "bankAccountTitleFallback": "Compte bancaire"
}
